// Extension to handle an un-editable HTML block in Quill editor

// Usage:
//    quill.insertEmbed(index, "htmlBlock", {html: "<...>...</...>"})

import Quill from "quill"
import Embed from "quill/blots/embed"

class HtmlBlock extends Embed {
  static blotName = "htmlBlock"
  static tagName = "span"
  static className = "html-block"

  static create(value) {
    let rootNode = super.create()

    // Create the content node
    const blockNode = document.createElement("span")
    blockNode.innerHTML = value.html
    blockNode.classList.add("html-block-content")
    blockNode.setAttribute("contenteditable", "false")

    rootNode.appendChild(blockNode)
    return rootNode
  }

  static value(node) {
    return {
      html: HtmlBlock.blockNode(node).innerHTML,
    }
  }

  static blockNode(node) {
    return node.querySelector(".html-block-content")
  }

  update_html(html) {
    const blockNode = HtmlBlock.blockNode(this.domNode)
    blockNode.innerHTML = html
  }
}

// Register our enhanced HtmlBlock
Quill.register(HtmlBlock)
